<template>
  <div class="w-full mx-auto px-10">
      <div class="pt-6 pb-4 flex justify-end">
          <button class="flex flex-row justify-center items-center"><p class="pr-2 text-costeaGray text-t14">Activar edición</p><i class="ri-pencil-fill text-t14 flex justify-center items-center text-costeaPrimary bg-costeaPrimaryDisabled p-1.5 h-7 w-7 rounded-full"></i></button>
      </div>
      <form action="#">
          <div class="grid grid-cols-2 gap-12">
              <div class="flex flex-col justify-center items-start">
                  <label for="nombre" class="text-costeaGray text-t14 relative leading-6">Nombre</label>
                  <input type="text" name="nombre" id="nombre" class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14" placeholder="Jane">
              </div>
              <div class="flex flex-col justify-center items-start">
                  <label for="apellido" class="text-costeaGray text-t14 relative leading-6">Apellido</label>
                  <input type="text" name='apellidos' id='apellidos' class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14" placeholder="Doe">
              </div>
          </div>
          <div class="grid grid-cols-2 gap-x-12 gap-y-1 mt-8">
              <h2 class="text-costeaBlack text-t14 mb-2 uppercase col-span-full font-medium">Documento de identidad</h2>
              <div class="flex flex-col justify-center items-start">
                  <label for="tipoIdentificacion" class="text-costeaGray text-t14 relative leading-6">Tipo de identificación</label>
                  <select name="tipoIdentificacion" id="tipoIdentificacion" class="bg-costeaContainer w-full h-10 justify-start items-center outline-none py-2 px-3 rounded-md text-t14">
                      <option value="1">Cédula de ciudadanía</option>
                      <option value="2">Licencia de conducir</option>
                      <option value="3">Pasaporte</option>
                  </select>
              </div>
              <div class="flex flex-col justify-center items-start">
                  <label for="numIdentificacion" class="text-costeaGray text-t14 relative leading-6">Numero de identificación</label>
                  <input type="text" name='numIdentificacion' id='numIdentificacion' class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14" placeholder="12345678">
              </div>
          </div>
          <div class="grid grid-cols-2 gap-x-12 gap-y-1 mt-8">
              <h2 class="text-costeaBlack text-t14 mb-2 uppercase col-span-full font-medium">Información de contacto</h2>
              <div class="flex flex-col justify-center items-start">
                  <label for="email" class="text-costeaGray text-t14 relative leading-6">Usuario (E-mail)</label>
                  <input type="email" name='email' id='email' class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14" placeholder="jane.doe@gmail.com">
              </div>
              <div class="flex flex-col justify-center items-start">
                  <label for="tel" class="text-costeaGray text-t14 relative leading-6">Teléfono de contacto</label>
                  <input type="text" name='tel' id='tel' class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14" placeholder="7000112">
              </div>
          </div>
          <div class="mt-8 mb-2 text-t12 flex justify-center">
              <button class="bg-costeaBtn2 px-7 py-3 rounded-md text-costeaPrimary mr-2 hover:bg-costeaBtn2Hover">Cancelar</button>
              <button class="bg-costeaPrimary px-7 py-3 rounded-md text-white ml-2 hover:bg-costeaHover">Actualizar</button>
          </div>
      </form>
  </div>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
export default {
    name: "BasicInfo",
    data(){
        return{
            user: []
        }
    },
    computed:{
        ...mapState(['costea'])
    },
    methods:{
        getUsuario(){
        const config = {
          headers:{
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data'
          }
        }
        axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}users`, config)
        .then(response =>{
          let data = response.data; 
          this.user =  data.filter(data =>{
            return data.email === localStorage.getItem('email')
          })
        })
        .catch(error =>{
          console.log(error)
        });
      },
    }
}
</script>

<style>

</style>